import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/more.svg'


const _withScopeId = n => (_pushScopeId("data-v-75dbe4b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "x flex-row items-center mb-4 pt-4 space-x-3" }
const _hoisted_2 = { class: "flex flex-row w-full" }
const _hoisted_3 = { class: "flex flex-row items-center justify-end" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-5 w-5",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
      "clip-rule": "evenodd"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-4" }, "Add account member")
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "flex flex-row justify-start" }
const _hoisted_7 = { class: "flex flex-row justify-start" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: "absolute flex flex-col bg-white right-0 rounded-2xl shadow hover:shadow-md p-2 w-60 z-50"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "txt-name text-right ml-4" }, "Remove collaborator")
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "txt-name text-right ml-4" }, "Re-send invitation")
], -1))
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_VueTableLite = _resolveComponent("VueTableLite")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_InviteMember = _resolveComponent("InviteMember")!
  const _component_ReusableModal = _resolveComponent("ReusableModal")!
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_SearchInput, {
            modelValue: _ctx.inputValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
            class: "bg-white",
            placeholder: "Search for a member...",
            onOnSubmit: _ctx.getAccountMembers
          }, null, 8, ["modelValue", "onOnSubmit"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "space-x-3 btn-filled-sm flex flex-row items-center disabled:opacity-50 justify-between truncate text-base bg-primary rounded-full transition duration-150 ease-in",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.InviteMember && _ctx.InviteMember(...args)))
          }, _hoisted_5)
        ])
      ]),
      _createVNode(_component_VueTableLite, {
        "is-loading": _ctx.table.isLoading,
        columns: _ctx.table.columns,
        rows: _ctx.table.rows,
        total: _ctx.table.totalRecordCount,
        sortable: _ctx.table.sortable,
        "is-slot-mode": true,
        "is-hide-paging": true
      }, {
        member: _withCtx((data) => [
          _createElementVNode("div", null, _toDisplayString(data.value.first_name === null
              ? "Not assigned"
              : data.value.first_name + " " + data.value.last_name), 1)
        ]),
        email: _withCtx((data) => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(data.value.email), 1)
          ])
        ]),
        roles: _withCtx((data) => [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", null, _toDisplayString(data.value.roles.join(", ")), 1)
          ])
        ]),
        menu: _withCtx((data) => [
          _createElementVNode("button", {
            class: "px-2",
            onClick: ($event: any) => (_ctx.openDropDown(data.value))
          }, _hoisted_10, 8, _hoisted_8),
          (data.value.id === _ctx.currentDropdown)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("button", {
                  class: "hover:bg-background p-2 rounded",
                  onClick: ($event: any) => (_ctx.deleteMember(data.value.id))
                }, _hoisted_14, 8, _hoisted_12),
                _createElementVNode("button", {
                  class: "hover:bg-background p-2 rounded",
                  onClick: ($event: any) => (_ctx.resendInvitation(data.value.id))
                }, _hoisted_17, 8, _hoisted_15)
              ])), [
                [_directive_click_away, _ctx.closeMenu]
              ])
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["is-loading", "columns", "rows", "total", "sortable"]),
      _createVNode(_component_Paginator, {
        modelValue: _ctx.page,
        page: _ctx.page,
        pages: _ctx.pagination.total_pages,
        "range-size": 1,
        "onUpdate:modelValue": _ctx.updateHandler,
        total: _ctx.pagination.total_count,
        from: _ctx.pagination.from,
        to: _ctx.pagination.to,
        class: "mt-8"
      }, null, 8, ["modelValue", "page", "pages", "onUpdate:modelValue", "total", "from", "to"])
    ]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.openModal,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openModal = false)),
      size: "lg:w-2/4 sm:w-full"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_InviteMember, {
          onCloseModal: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openModal = false)),
          onReloadMembers: _ctx.getAccountMembers
        }, null, 8, ["onReloadMembers"])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}